import axios from "axios";
import env from "../variables/EndpointEnvironment";

const ShortDescriptionAPI = (props) => {
  return axios.get(`${env.HOST}/deskripsi-singkat?loc=${props.loc}`, {
    headers: {
      "Content-Language": localStorage.getItem('i18nextLng'),
    },
  });
};

export default ShortDescriptionAPI;
